import axios from 'axios';
import router from '../../core/router/index';

axios.defaults.timeout = 30000;

import authService from '../services/auth.service';
import emitter from '@/core/config/emitter';
import { MANAGE_ELIOT_PARSE_EXCEPTION } from './emitter-events';
import globalErrors from './global-errors';

axios.interceptors.request.use(async (config) => {
  const token = await authService.getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else config.headers.Authorization = '';
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    globalErrors.addError(JSON.stringify(error.toJSON()));
    if (error.response.status === 412) {
      emitter.emit(MANAGE_ELIOT_PARSE_EXCEPTION);
    } else if (error.response.status === 477) {
      // user is not in allowed list
      router.push({ name: 'page-user-not-allowed' });
    } else {
      return Promise.reject(error);
    }
  }
);

export default axios;
